<template>
  <div class="list-swiper1">
    <swiper
      ref="mySwiper"
      class="swiper"
      :options="swiperOptions"
      @slideChangeTransitionStart="slideChangeTransitionStart"
      @click="onSwiperClick"
    >
      <swiper-slide
        v-for="(item, index) in list"
        :key="index"
        class="swiper-item"
      >
        <img :src="item.images | image_filter" alt="">
        <div class="info">
          <h3 class="title">{{ item.title }}</h3>
          <ul class="tags">
            <li v-for="(item1, index1) in tagArray(item.keywrod)" :key="index1">
              {{ item1 }}
            </li>
          </ul>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "SWIPER1",
  components: {
    Swiper,
    SwiperSlide,
  },
  filters: {
    image_filter(val) {
      const images = val.split(",");
      return images[0];
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
      swiperOptions: {
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
          dynamicBullets: true,
          dynamicMainBullets: 2,
        },
        slidesPerView: "auto",
        spaceBetween: 0,
      },
    };
  },
  computed: {
    list() {
      return this.data;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  methods: {
    tagArray(value) {
      return value.split(",");
    },

    onTabsClick() {
      this.swiper.slideTo(this.active);
      this.swiper.update();
    },

    slideChangeTransitionStart() {
      this.active = this.swiper.activeIndex;
    },

    onSwiperClick() {
      const item = this.data[this.active];
      this.$router.push({
        path: "/cate/info",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.list-swiper1{
  height: 100%;
  display: flex;
  align-items: center;
  color: #fff;

  .swiper {
  ::v-deep .swiper-slide {
    height: auto;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);

    &.swiper-slide-prev,
    &.swiper-slide-next,
    &.swiper-slide-active {
      transition: all 0.6s;
    }

    &.swiper-slide-active {
      transform: scale(1);
    }

    img {
      border-radius: 4px;
      height: 100%;
    }

    .info {
      position: absolute;
      left: 20px;
      bottom: 10px;

      .tags {
        margin-top: 5px;
        li {
          float: left;
          font-size: 10px;
          border-width: 1px;
          border-style: solid;
          margin: 5px 0;
          padding: 5px;
          border-radius: 4px;
          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
}

@media screen and (max-width: 800px) {
  .swiper-item {
    width: 260px;
  }
}

@media screen and (min-width: 800px) {
  .swiper-item {
    width: 400px;
  }
}
</style>
